<template>
  <div id="app">
     <!--ProductList :production="production" /-->
     <!--Member :production="production" /-->
     <!--Product :production="production" /-->
     <!--Checkout :production="production" /-->
     <!--Finish :production="production" /-->
     <Search :production="production" />
  </div>
</template>

<script>
// import ProductList from "./ProductList";
// import Product from "./Product";
// import Checkout from "./Checkout";
// import Member from "./Member";
// import Finish from "./Finish";
 import Search from "./Search";
require('es6-promise').polyfill();
require('isomorphic-fetch');
export default {
  name: "App",
  components: {
    // ProductList
    // Member
    // Checkout
    // Product
    // Finish
     Search
  },
  data() {
    return {
      production: true,
      bankTransferMsg: "test123<br>test123<br>test123",
      paypalMerchantId: "AafwDHSQFtNWtoKe9TJEinE_V_eq9fijTq4SNi30qeJ6D_K0HCSQnXru_xe6VJEr8I51LD8qpTSBNDfY"
    };
  },
  beforeMount() {
    if (this.production) {
      let appWrapper = document.getElementById("appWrapper");
      let lang = appWrapper.getAttribute("data-language");
      if(lang && lang != ""){
        this.$i18n.locale = lang;
      }else{
        this.$i18n.locale = "zh-tw";
      }
    }else{
      this.$i18n.locale = "zh-tw";
    }
  }
};
</script>
